import { Map } from "immutable"
// flow
import * as fp from "lodash/fp"

// Cannot use keymirror yet
// todo: remove hand, hand2
export const BAGS_TYPES = {
  HAND: "hand",
  HOLD: "hold",
  HAND2: "hand2",
  STROLLER: "stroller",
  POBEDA: "pobeda",
  CABIN_BAG: "cabin_bag",
  PERSONAL_ITEM: "personal_item",
  HOLD_BAG: "hold_bag",
}

export const computeNthBagPrice = (pricing, index) => pricing.get(index.toString())

export const trimPaidBagsFromPricing = pricing => {
  const _pricing = {}

  // to problem converting .toList().toMap() returns map with numbered keys
  pricing
    .filter(Boolean) // Only non zero values
    .toList()
    .forEach((x, i) => {
      _pricing[i + 1] = x // Index from "1"
    })

  return Map(_pricing)
}

export const computeTotalBagsTypePrice = (passengers, pricing, type) =>
  passengers.reduce((acc, p) => {
    let pAcc = 0

    for (let i = 1; i <= p[type].value; i++) {
      pAcc += computeNthBagPrice(pricing, i)
    }

    return acc + pAcc
  }, 0)

export const computeTotalHoldBagsTypePrice = (passengers, pricing, type, prop) =>
  passengers.reduce((acc, pap) => {
    for (let i = 1; i <= pap[type].value; i++) {
      // eslint-disable-next-line no-param-reassign
      acc += fp.get([i, prop || "amount"], pricing)
    }
    return acc
  }, 0)

// TODO: Rename to `hasPaidHandBagsAllowedFrom`
export const hasPaidHandBagsAllowed = (pricing, journey) =>
  !!pricing && !!trimPaidBagsFromPricing(pricing).size && journey.hasPaidHandBagsAllowed()

// Used in mmb
export const hasPaidHandBagsAllowedFromPassengers = (passengers, journey) =>
  !!passengers.filter(x => !fp.isUndefined(x.handBags)).length && journey.hasPaidHandBagsAllowed()
